import { render, staticRenderFns } from "./FightReport.vue?vue&type=template&id=915be288&scoped=true"
import script from "./FightReport.vue?vue&type=script&lang=js"
export * from "./FightReport.vue?vue&type=script&lang=js"
import style0 from "./FightReport.vue?vue&type=style&index=0&id=915be288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915be288",
  null
  
)

export default component.exports